import React, { useEffect, useState } from "react";
import './_GenericDemographicsQuestionList.scss'
// import AssessmentDemographicOptions from './AssessmentDemographicOptions.json'
import Arrow from '../../../assets/upgrade-images/Arrow.svg'
import Loader from "../../CommonComponent/Loader/Loader";
import { useSelector, useDispatch } from "react-redux"
import { useHistory } from "react-router-dom";
import { Paths } from "../../routes/routePaths";
import { fetchGenericDemographicQuestions, submitGenericDemographicsQuestions } from '../../../Services/GenericSevices/GenericSevices'
import { GameStaticData } from "../../../StaticData/GameStaticData";

const GenericDemographicsQuestionList = ({ isHeaderManu, redirectUrl, userOrgType }) => {
    const { profileReducer, surveyQuestionsReducers, loader } = useSelector(state => state)
    const profileDetail = profileReducer?.profileDetail?.data?.user
    const { demographicQuestionData } = surveyQuestionsReducers
    const history = useHistory();
    const [selectedAnsweredQuestions, setSelectedAnsweredQuestions] = useState([])
    const [isErrorMessage, setIsErrorMessage] = useState({
        type: '',
        message: '',
        notSelectOptions: []
    })
    let { isLoading } = loader
    const dispatch = useDispatch()

    useEffect(() => {
        let isGameCompleted = Object.values(profileDetail?.game_completion || {})

        if((GameStaticData.length !== isGameCompleted.length) || isGameCompleted.includes(false) || isGameCompleted.includes('InProgress')){
            history.push( userOrgType === 'prolific' ? '/prolific-dashboard' : '/generic-dashboard')
        }
    }, [profileDetail]);

    useEffect(() => {
        getMturkDemoGraphicsQuestions()
        // eslint-disable-next-line 
    }, [])

    useEffect(() => {
      if (demographicQuestionData?.filled_demographic) {
        history.push(redirectUrl || Paths.GenericQuestionnaire)
      }
      // eslint-disable-next-line
    }, [demographicQuestionData?.filled_demographic])

    const getMturkDemoGraphicsQuestions = async () => {
        dispatch(fetchGenericDemographicQuestions())
    }

    const handleFormSubmitData = (e) => {
        e.preventDefault();

        const formElements = e.target.elements;
        let formData = [];
        for (let element of formElements) {
            const { name, value, type } = element;
            if (type === 'select-one' && value) {
                const questionId = Number(name);
                let question = demographicQuestionData?.questions.find(question => question?.que_id === questionId)
                let sleectedoption = question?.options.find((option) => option?.label === value)
                let submitObj = {
                    user_id: profileDetail ? profileDetail?.id : '',
                    question_label: question.question_label,
                    selected_response: [value],
                    answer_text: null,
                    survey_question_id: question.que_id,
                    selected_option_number: sleectedoption?.id
                }
                formData = [...formData, submitObj]
            }
        }
        submitAnswers(formData)
    }

    const submitAnswers = async (data) => {
        let { questions } = demographicQuestionData
        if (questions.length === data?.length) {
            let payload = {
                demographics: true,
                survey_response: data
            }
            let submitResponse = await dispatch(submitGenericDemographicsQuestions(payload))
            if (submitResponse?.status === 200) {
                history.push(redirectUrl || Paths.GenericQuestionnaire)
            } else {
                setIsErrorMessage({
                    type: 'unFill all value',
                    message: 'Something went wrong!',
                    notSelectOptions: []
                }) 
            }
        } else {
            let notSelectOptions = questions.filter(item => !selectedAnsweredQuestions.includes(item?.que_id))
            setIsErrorMessage({
                type: 'unFill all value',
                message: 'Please ensure all questions are answered before submitting the form. Your responses are important to us. Thank you for your cooperation.',
                notSelectOptions: notSelectOptions?.map(item => item?.que_id)
            })
        }
    }

    const handleChange = (e) => {
        let { name } = e.target

        let remainingSelectedAnswer = selectedAnsweredQuestions.includes(parseInt(name)) ? selectedAnsweredQuestions : [...selectedAnsweredQuestions, parseInt(name)]

        setSelectedAnsweredQuestions(remainingSelectedAnswer)
        setIsErrorMessage({
            type: '',
            message: '',
            notSelectOptions: isErrorMessage?.notSelectOptions?.filter(item => item !== parseInt(name))
        })

    }
    return (
        <>
            <main className="talwind-dashboard max-w-xs mx-auto pt-24 pb-20 flex flex-col gap-6 w-full transition-all duration-300 sm:max-w-[420px] md:max-w-[calc(100vw-80px)] md:pl-16">
                <div id="main_section" className={isHeaderManu ? "flex flex-col gap-6 transition-all duration-30 md:w-[72%] lg:w-[79%] xl:w-[84.5%] 2xl:w-[86.5%] 3xl:w-[90%] m-auto"
                    : "flex flex-col gap-6 transition-all duration-30 md:w-[72%] lg:w-[79%] xl:w-[84.5%] 2xl:w-[86.5%] 3xl:w-[90%] md:ml-auto"}>
                    <div className="pt-2">
                        <span className="font-rubik font-semibold text-[#1A1919] text-xl md:text-2xl dark:text-[#F5F5F5]">Select the following options listed below.</span>
                    </div>
                    <div
                        className="bg-white px-4 py-7 rounded-2xl dark:bg-[#212121] transition-all duration-300 text-sm"
                    >

                        <form
                            className="flex flex-col gap-6"
                            action=""
                            id="settingForm"
                            name="settingForm"
                            onSubmit={handleFormSubmitData}
                            onInput={handleChange}

                        >
                            <div
                                className="input_group flex flex-wrap"
                            >
                                {
                                    isLoading ? <Loader />
                                        : demographicQuestionData?.questions?.length > 0 && demographicQuestionData?.questions instanceof Array ?
                                            <>
                                                {demographicQuestionData?.questions?.map((question, index) => {
                                                    return (
                                                        <div className="basis-1/2 gap-3">
                                                            {
                                                                question.ques_type === 'radio' ? <></>
                                                                    :
                                                                    <div className="w-full relative z-0 px-2 group mb-5">
                                                                        <div class="relative">
                                                                            <div className="relative">

                                                                                <select
                                                                                    name={question.que_id}
                                                                                    id={question?.que_id}
                                                                                    placeholder="Select cummunity"
                                                                                    className={`bg-white text-black border py-4 px-3 ${isErrorMessage?.notSelectOptions?.includes(question.que_id) ? 'border-red-800' : 'border-[#0000003B]'}  text-[#9299D] rounded-lg appearance-none block w-full transition-all bg-transparent relative z-10 duration-300 dark:bg-[#212121] dark:border-[#F5F5F5] dark:text-white outline-none disabled:bg-[#F5F5F5] disabled:bg-[#F5F5F5]`}
                                                                                >
                                                                                    <option value={''} className="text-black">Select</option>
                                                                                    {question?.options && question.options.map((option, optionsIndex) => {
                                                                                        return <option className="text-black" key={optionsIndex} value={option.label === 'Select' ? '' : option?.label}>{option.label}</option>
                                                                                    })}
                                                                                </select>
                                                                                <div className="downArrow absolute top-[25%] right-3">
                                                                                    <img
                                                                                        className="dark:invert"
                                                                                        src={Arrow}
                                                                                        alt="Arrow"
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                            <label for="floating_outlined" className={`absolute text-md ${isErrorMessage?.notSelectOptions?.includes(question.que_id) ? 'font-bold text-red-800 dark:text-orange-600' : 'text-black dark:text-gray-50'}   duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-1 peer-focus:px-1 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-2 line-clamp-1 text-nowrap`}>
                                                                                {question?.question_label}
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                            }
                                                        </div>
                                                    )

                                                })}
                                                <div className="flex items-end justify-end">
                                                    <p className="font-bold text-red-800 dark:text-orange-600 py-3">
                                                        {isErrorMessage?.type ? isErrorMessage?.message : ""}
                                                    </p>
                                                </div>
                                                <div
                                                    className="form_submit grid gap-4 grid-cols-1 md:grid-cols-2 w-3/4 lg:grid-cols-3 xl:grid-cols-4"
                                                >
                                                    <button
                                                        type="submit"

                                                        className="rounded bg-[#1B75BC] text-[#FFFFFF] py-2"
                                                    >
                                                        Submit
                                                    </button>
                                                </div>
                                            </>
                                            : <div className="flex items-center justify-center">
                                                <h6>No Question Available!</h6>
                                            </div>
                                }

                            </div>

                        </form>
                    </div>
                </div>
            </main>
        </>
    )
}

export default GenericDemographicsQuestionList;